import { useAppDispatch, useAppSelector } from "@/app/appStore";
import {
  selectCurrentCamera,
  selectSelectedPolygon,
  setSelectedPolygon,
} from "@/entities/annotation";
import useCameraHandlers from "@/features/annotation/hooks/useCameraHandlers";
import { SkuSidebar } from "@/features/sku-sections/components/sku-sidebar";
import { findCamerasWithSkuSection } from "@/features/sku-sections/lib/find-cameras-with-sku";
import { useGondolasSkuSectionsQuery } from "@/shared/api/insights-api";
import { FilterSection } from "./filter-section";
import SkuSectionChangeGroupDetails from "./sku-section-change-group-details";
import { useGondolaChangeGroupsData } from "../hooks";
import { ScrollArea } from "@radix-ui/themes";

const RightSidebar = () => {
  const dispatch = useAppDispatch();
  const selectedPolygon = useAppSelector(selectSelectedPolygon);
  const currentCamera = useAppSelector(selectCurrentCamera);
  const { handleCameraSelect } = useCameraHandlers();
  const selectedOrder = useAppSelector(
    (state) => state.annotation.selectedOrder
  );

  const { selectedGondolaChangeGroup } = useGondolaChangeGroupsData();
  const { data: skuSectionsData } = useGondolasSkuSectionsQuery(
    {
      gondolaId: String(selectedGondolaChangeGroup?.gondola_id),
    },
    { skip: !selectedGondolaChangeGroup?.gondola_id || !selectedOrder }
  );

  const handleProjectionClick = (cameraId: string) => {
    if (cameraId !== currentCamera) {
      handleCameraSelect(cameraId);
    }
  };

  const camerasWithSelectedSkuSection =
    selectedPolygon && skuSectionsData
      ? findCamerasWithSkuSection(
          selectedPolygon.sku_section_id,
          skuSectionsData
        )
      : null;

  const handleClose = () => {
    dispatch(setSelectedPolygon(null));
  };

  if (selectedPolygon) {
    return (
      <ScrollArea>
        <SkuSidebar
          selectedPolygon={selectedPolygon || null}
          selectedSkuSectionId={selectedPolygon.sku_section_id}
          onProjectionClick={handleProjectionClick}
          projections={camerasWithSelectedSkuSection}
          selectedCamera={currentCamera}
          onClose={handleClose}
        />
        <SkuSectionChangeGroupDetails />
      </ScrollArea>
    );
  }

  return <FilterSection />;
};

export default RightSidebar;
